import React from "react";
import _ from "lodash";
import { add } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";
import { AuthErrorCode, isFailure } from "@sportal/api";

import { sleep } from "../../helpers/promises.helper";
import { ModalService } from "../modal";
import { DeeplinkSuccessDialog, DeeplinkErrorDialog } from "./DeeplinkDialog";
import { is24HourFormat, getTimeZone } from "../../store/account";
import { getSubscriberId } from "../../store/info/info.selectors";

export const generateDeeplink =
  ({ delayMs } = {}) =>
  async (dispatch, getState, { api }) => {
    if (delayMs) {
      await sleep(delayMs);
    }

    const state = getState();
    const id = getSubscriberId(state);

    const result = await api.ssm.account.generateDeeplink(id);

    if (isFailure(result)) {
      if (result.error.code === AuthErrorCode.SESSION_IS_EXPIRED) {
        dispatch({ payload: result.error, type: GENERATE_DEEPLINK_FAILURE });
        return;
      }

      function onTryAgain() {
        dispatch(generateDeeplink({ delayMs: 1000 }));
      }

      ModalService.show((modal) => ({
        dialog: <DeeplinkErrorDialog modal={modal} />,
      })).then(() => onTryAgain(), _.noop);
      return;
    }

    const expirationDuration = result.data["deeplink-ttl"];
    const { link } = result.data;
    const is24 = is24HourFormat(state);
    const tz = getTimeZone(state);

    ModalService.show((modal) => {
      const now = utcToZonedTime(Date.now(), tz);
      const expires = format(
        add(now, { seconds: expirationDuration }),
        is24 ? "MM/dd/yyyy HH:mm" : "MM/dd/yyyy hh:mm aaa"
      );

      dispatch({ type: GENERATE_DEEPLINK_SUCCESS, payload: { link, expires } });

      return {
        dialog: (
          <DeeplinkSuccessDialog modal={modal} link={link} expires={expires} />
        ),
      };
    }).then(_.noop, _.noop);
  };

export const copiedToClipboard = () => (dispatch) => {
  dispatch({ type: COPIED_TO_CLIPBOARD });
};

export const GENERATE_DEEPLINK = "[SPSON] GENERATE_DEEPLINK";
export const GENERATE_DEEPLINK_SUCCESS = "[SPSON] GENERATE_DEEPLINK_SUCCESS";
export const GENERATE_DEEPLINK_FAILURE = "[SPSON] GENERATE_DEEPLINK_FAILURE";
export const COPIED_TO_CLIPBOARD = "[SPSON] COPIED_TO_CLIPBOARD";
